import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  BuildingOfficeIcon, 
  BuildingStorefrontIcon, 
  UserGroupIcon, 
  GlobeAltIcon
} from '@heroicons/react/24/outline';
import { 
  ProspectionViewType, 
  selectCurrentView, 
  setCurrentView,
  setCurrentPage,
  ProspectionViewValues
} from '../../store/slices/nouveauxAdherentsSlice';

const ProspectionTabs: React.FC = () => {
  const dispatch = useDispatch();
  const currentView = useSelector(selectCurrentView);

  const handleTabChange = (view: ProspectionViewType) => {
    if (view !== currentView) {
      dispatch(setCurrentView(view));
      dispatch(setCurrentPage(1)); // Reset to page 1 when changing view
    }
  };

  const tabs = [
    {
      id: ProspectionViewValues.NEW_ESTABLISHMENTS_NEW_COMPANIES,
      name: "Nouvelles entreprises",
      icon: BuildingOfficeIcon,
      description: "Établissements sièges non clients dans votre secteur"
    },
    {
      id: ProspectionViewValues.NEW_ESTABLISHMENTS_EXISTING_COMPANIES_IN_YOUR_SECTOR,
      name: "Entreprises locales",
      icon: BuildingStorefrontIcon,
      description: "Établissements non sièges non clients dont le siège est dans votre secteur"
    },
    {
      id: ProspectionViewValues.NEW_ESTABLISHMENTS_EXISTING_COMPANIES_OUT_OF_SECTOR,
      name: "Entreprises extérieures",
      icon: GlobeAltIcon,
      description: "Établissements non sièges non clients dont le siège est hors de votre secteur"
    },
    {
      id: ProspectionViewValues.NON_CLIENT_FROM_CLIENT_COMPANIES,
      name: "Groupes clients",
      icon: UserGroupIcon,
      description: "Entreprises non-clientes dans des groupes clients"
    }
  ];

  return (
    <div className="mb-6">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Sélectionner une vue
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          defaultValue={currentView}
          onChange={(e) => handleTabChange(e.target.value as ProspectionViewType)}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block overflow-x-auto max-w-full pb-2">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => {
              const isActive = tab.id === currentView;
              const Icon = tab.icon;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`
                    flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                    ${isActive
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                  aria-current={isActive ? 'page' : undefined}
                >
                  <Icon 
                    className={`-ml-0.5 mr-2 h-5 w-5 ${isActive ? 'text-blue-500' : 'text-gray-400'}`} 
                    aria-hidden="true" 
                  />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default ProspectionTabs; 